<template>
  <div class="results" ref="results" v-on:click="toggleBgOnly" v-bind:class="{'bg-only': bgOnly}">
    <div class="overlay" v-bind:style="{'backgroundColor': backgroundColor }"></div>
    <GoBack currentScreen="results"/>

    <ResultsViews @gallery="goToColorWall" @list="goToColorList" />
    <ResultsPopup ref="popUp"/>

    <div class="results__headline">{{ selectedColor.popular ? "Most popular choice" : resultTitle}}</div>
    <h1 :inner-html.prop="selectedColor.colourName | colourTitleHtml"></h1>
    <h2>{{selectedColor.id}}</h2>

    <div class="results__start-again">Not right? <a v-on:click="startAgain()" ref="startAgain"><b>Start again</b></a></div>

    <div class="results__bottom" ref="resultsBottom">

      <AnimatedButton :text="buttonText" ref="viewOnColourwall"
                  v-on:click="handleOnClick()"></AnimatedButton>

      <p v-if="mobileView">Complimentary colours</p>
    </div>

    <div class="results__complimentary-section" ref="complimentaryColours">
      <div class="results__complimentary">Complimentary colours</div>
      <div class="results__complimentary" 
           v-for="(item, i) in selectedColor.complimentaryColours"
           v-on:click="selectComplimentaryColour($event, item)"
           :key="item.colourName + i"
           v-bind:class="lightOrDark('rgb('+ item.red + ',' + item.green + ',' + item.blue + ')') ? 'dark' : 'light'"
           v-bind:style="{'backgroundColor': 'rgb('+ item.red + ',' + item.green + ',' + item.blue + ')'}">
        <strong :inner-html.prop="item.colourName | colourTitleHtml"></strong><br/>
        {{item.id}}
      </div>
    </div>
  </div>
</template>

<script>
import { upperFirst, keyBy } from 'lodash'
import { event } from 'vue-analytics'
import AnimatedButton from './elements/AnimatedButton'
import GoBack from './elements/GoBack.vue'
import ResultsPopup from './elements/results/Popup'
import ResultsViews from './elements/results/ResultsViews'
import {randomTitlesResults, bunningsUrls} from '../assets/data/data.js'
import allColours from '../assets/data/allColours.json'
import {lightOrDark} from '../assets/data/lightOrDark'

export default {
  name: 'Results',
  components: { AnimatedButton, GoBack, ResultsPopup, ResultsViews },

  data() {
    return {
      currentPattern: this.$store.state.currentPattern,
      lightOrDark: lightOrDark,
      mobileView: true,
      resultTitle: randomTitlesResults[Math.floor(Math.random() * Math.floor(randomTitlesResults.length))],
      bgOnly: false
    }
  },
  computed: {
    accessMode() {
      return this.$route.query.access
    },
    selectedColor : function() {
      return this.allColourMap[this.$store.state.selectedColor.colourName.toLowerCase()];
    },
    backgroundColor() {
      return this.$store.state.backgroundColor;
    },
    allColourMap() {
      return keyBy(allColours, color => color.colourName.toLowerCase())
    },
    buttonText() {
      switch (this.accessMode) {
        case 'qr':
          return 'View on Colourwall'
        default:
          return 'Buy online at Bunnings'
      }
    },
    interiorOrExterior() {
      let intExt = "";
      if (this.$store.state.interiorOrExterior.length === 0) {
        intExt = "interior";
      } else {
        intExt = this.$store.state.interiorOrExterior;
      }

      return intExt;
    },
    colorBase : function() {
      let base = "";
      if (this.selectedColor == undefined || this.selectedColor.base == undefined || this.selectedColor.base === "") {
        base = "white";
      } else if (this.selectedColor.base.interior != undefined ) {
        // If this colour has different base based on interior/exterior paint
        base = this.selectedColor.base[this.interiorOrExterior];
      } else {
        // If this colour has just 1 base
        base = this.selectedColor.base;
      }
      return base;
    },
  },
  watch: {
    selectedColor(newValue) {
      this.updateBg(newValue);
    }
  },
  created() {
  },
  mounted() {
    this.updateBg(this.selectedColor);
    this.handleResize();
    this.$store.commit('updateSelectedColor', this.selectedColor);
  },
  methods: {
    startAgain() {
      event('start_again', 'Click')
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    toggleBgOnly(event) {
      const ignoredRefs = [this.$refs.viewOnColourwall, this.$refs.popUp, this.$refs.startAgain, this.$refs.complimentaryColours];
      if (ignoredRefs.indexOf(event.target) === -1 && event.target.type !== 'submit') {
        this.bgOnly = !this.bgOnly
      }
    },
    updateBg(colour) {
      this.$store.commit('updateBg', [colour.red, colour.green, colour.blue])
    },
    handleResize() {
      window.innerWidth > 767 ? this.mobileView = false : this.mobileView = true
    },
    handleOnClick() {
      event('Colourwall', 'Click')

      if (this.accessMode === 'qr') {
        event(upperFirst(this.interiorOrExterior), 'ViewonColourwall', this.selectedColor?.colourName)
        this.goToColorWall();
      } else {
        if (this.selectedColor.base === undefined) {
          // If no base is set, send straight to bunnings
          if (this.interiorOrExterior == "interior") {
            window.open('https://www.bunnings.com.au/our-range/paint-decorating/paint/interior/wall?facets=BrandName%3DBritish%20Paints', "_blank")
          } else {
            window.open('https://www.bunnings.com.au/our-range/paint-decorating/paint/exterior/wall?facets=BrandName%3DBritish%20Paints', "_blank") 
          }
        } else { 
          // If base is set, select sheen screen
          var urlOptions = bunningsUrls[this.interiorOrExterior][this.colorBase];
          var numOptions = 0;
          var thatOption = "";
          for (var key in urlOptions) {
            if (urlOptions[key].length > 0) {
              numOptions++
              thatOption = urlOptions[key]
            }
          }
          if (numOptions == 1) {
          // If base is set, but there is only one link
            window.open(thatOption)
          } else {
          // If base is set, and only if there's more than one option
            this.$router.push('/one-more-thing');
          }
        }
      }
    },
    goToColorWall() {
      this.$router.push({ name: 'resultsGallery', params: { primaryColor: this.selectedColor }});
    },
    goToColorList() {
      this.$router.push('/results-list')
    },
    findInAllColours(){ //match result from questionsJourney.json to allColours.json
      for (var i = 0; i < allColours.length; i++) {
        if (this.selectedColor.id === allColours[i].id) {
          this.$store.commit('updateSelectedColor', allColours[i])
        }
      }
    },
    goToWebsite() {
      if (this.interiorOrExterior === 'interior') {
        window.open('https://www.bunnings.com.au/our-range/paint-decorating/paint/interior/wall?facets=BrandName%3DBritish%20Paints', "_blank")
      } else { 
        window.open('https://www.bunnings.com.au/our-range/paint-decorating/paint/exterior/wall?facets=BrandName%3DBritish%20Paints', "_blank") 
      }
    },
    selectComplimentaryColour(event, colour) {
      event.stopPropagation();
      this.$store.commit('updateSelectedColor', colour)
    }
  }
}
</script>
